import type { HbBidderConfig } from '../types'

export const ONETAG: HbBidderConfig = {
    bidder: 'onetag',
    params: ({ placement }) => ({
        pubId: '96270e85fa98b10',
        ext: { placement_name: placement },
    }),
}
